import React, { useRef } from "react"
import { Card, CardBody, Button, Row, Col } from "reactstrap"
import PropTypes from "prop-types"
import formatCurrency from "constants/formatCurrency" // Assuming you have this
import formatDate from "constants/formatDate"         // Assuming you have this

const LocationParkingLots = ({ parkingLots, onAdd }) => {
    const scrollRef = useRef(null)

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { current } = scrollRef
            const scrollAmount = 320 // Width of card + gap
            if (direction === "left") {
                current.scrollBy({ left: -scrollAmount, behavior: "smooth" })
            } else {
                current.scrollBy({ left: scrollAmount, behavior: "smooth" })
            }
        }
    }

    // Helper for row data styling
    const LotRow = ({ label, value, isLink }) => (
        <div className="d-flex justify-content-between align-items-center mb-2" style={{ fontSize: "13px" }}>
            <span style={{ color: "#999", fontWeight: "500" }}>{label}</span>
            <span
                style={{
                    color: isLink ? "#FFCA5C" : "#FFF",
                    fontWeight: isLink ? "400" : "600",
                    textAlign: "right",
                    maxWidth: "60%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}
            >
                {value || "-"}
            </span>
        </div>
    )

    return (
        <div className="mb-4">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 style={{ color: "#FFCA5C", fontWeight: "bold", margin: 0 }}>Parking Lots</h5>
                {/* <Button
                    size="sm"
                    style={{
                        backgroundColor: "#7BB64E",
                        border: "none",
                        borderRadius: "20px",
                        padding: "5px 15px",
                        fontWeight: "bold"
                    }}
                    onClick={onAdd}
                >
                    + Add Lots
                </Button> */}
            </div>

            {/* Slider Container */}
            <div className="position-relative d-flex align-items-center">

                {/* Left Arrow */}
                <div
                    onClick={() => scroll("left")}
                    style={{
                        cursor: "pointer",
                        zIndex: 10,
                        padding: "10px",
                        display: parkingLots && parkingLots.length > 2 ? "block" : "none"
                    }}
                >
                    <i className="bx bx-chevron-left text-white" style={{ fontSize: "24px" }}></i>
                </div>

                {/* Scrollable Area */}
                <div
                    ref={scrollRef}
                    className="d-flex"
                    style={{
                        overflowX: "auto",
                        scrollBehavior: "smooth",
                        gap: "20px",
                        width: "100%",
                        paddingBottom: "10px", // Hides scrollbar in some browsers or adds spacing
                        scrollbarWidth: "none", // Firefox
                        msOverflowStyle: "none" // IE 10+
                    }}
                >
                    {/* Hide Scrollbar for Chrome/Safari/Opera */}
                    <style>
                        {`
                    .d-flex::-webkit-scrollbar {
                        display: none;
                    }
                `}
                    </style>

                    {parkingLots && parkingLots.length > 0 ? (
                        parkingLots.map((lot, index) => (
                            <Card
                                key={index}
                                style={{
                                    minWidth: "350px", // Fixed width for sliding consistency
                                    maxWidth: "300px",
                                    backgroundColor: "#383838",
                                    borderRadius: "15px",
                                    border: "none",
                                    flexShrink: 0
                                }}
                            >
                                <CardBody className="p-4">
                                    <h5 className="mb-4" style={{ color: "#FFCA5C", fontWeight: "bold" }}>
                                        Lot {index + 1}
                                    </h5>

                                    <LotRow label="Type" value={lot.type} />
                                    <LotRow label="Spaces" value={lot.spaces} />
                                    <LotRow label="Access Hours" value={lot.access_hours} />
                                    <LotRow label="Rent Amount" value={lot.rent_amount ? `$${formatCurrency(lot.rent_amount)}` : null} />
                                    <LotRow label="Due Date" value={lot.due_date ? formatDate(lot.due_date) : "-"} />
                                    <LotRow label="Payee Name" value={lot.payee_name} isLink />
                                    <LotRow label="Payee Email" value={lot.payee_email} isLink />
                                    <LotRow label="Payee Phone" value={lot.payee_phone} isLink />
                                    <LotRow label="Rules" value={lot.rules} />

                                </CardBody>
                            </Card>
                        ))
                    ) : (
                        <div className="text-muted w-100 text-center py-5" style={{ backgroundColor: "#383838", borderRadius: "15px" }}>
                            No parking lots found. Click "Add Lots" to start.
                        </div>
                    )}
                </div>

                {/* Right Arrow */}
                <div
                    onClick={() => scroll("right")}
                    style={{
                        cursor: "pointer",
                        zIndex: 10,
                        padding: "10px",
                        display: parkingLots && parkingLots.length > 2 ? "block" : "none"
                    }}
                >
                    <i className="bx bx-chevron-right text-white" style={{ fontSize: "24px" }}></i>
                </div>
            </div>
        </div>
    )
}

LocationParkingLots.propTypes = {
    parkingLots: PropTypes.array,
    onAdd: PropTypes.func
}

export default LocationParkingLots